export const HEADER_SIGNIN = 'signIn';
export const HEADER_SIGNUP = 'signUp';
